export default __webpack_public_path__ + "static/media/16_gallery.8891c7ad.jpg";